import React from "react";
import { Link } from "gatsby";

import WafdData from "../../json/wafd-data.json";
import ServiceStatesMapSmall from "./service-states-map-sm";
import SpanishServiceStatesMapSmall from "./service-states-map-spanish-sm";
import ServiceStatesLinks from "./service-states-links";
import { useLanguageContext } from "../../contexts/language-context";

const ServiceStates = () => {
  const isSpanish = useLanguageContext();
  return (
    <section id="service-states-section" className="container">
      <div className="row">
        <div className="col-md-6">
          <h1>
            {isSpanish
              ? "WaFd Bank, su banco local para su banca personal y comercial"
              : "WaFd Bank, Your Local Bank for Your Personal & Business Banking"}
          </h1>
          <div className="row">
            <div className="col-12 mb-3">
              {isSpanish ? (
                <ul>
                  <li>
                    WaFd Bank es un banco local y un prestamista de cartera con más de 200 sucursales en 8 estados para
                    servirle
                  </li>
                  <li>Más de 32.000 cajeros automáticos SIN CARGO</li>
                  <li>
                    Banca móvil y en línea las 24 horas del día, los 7 días de la semana con depósito de cheques móvil
                  </li>
                  <li> Cajero automático de Drive Up</li>
                </ul>
              ) : (
                <ul>
                  <li>
                    WaFd Bank is a local bank and portfolio lender with more than 200 branches in 8 states to serve you
                  </li>
                  <li>Over 32,000 FEE-FREE ATMs</li>
                  <li>24/7 online &amp; mobile banking with mobile check deposit</li>
                  <li>Drive up ATMs</li>
                </ul>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-8 mb-3">
              <Link to={WafdData.urls.atmLocator} className="btn btn-block btn-primary" role="button">
                {isSpanish ? "Encuentra un cajero automático" : "Find an ATM"}
              </Link>
              <a href={isSpanish ? "/es/sucursales" : "/locations"} className="btn btn-block btn-primary" role="button">
                {isSpanish ? "Encuentre una sucursal local" : "Find a local branch"}
              </a>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <ServiceStatesLinks />
            </div>
          </div>
        </div>

        <div id="service-states-map-section" className="d-none d-md-block col-md-6 center-block">
          {isSpanish ? <SpanishServiceStatesMapSmall /> : <ServiceStatesMapSmall />}
        </div>
      </div>
    </section>
  );
};

export default ServiceStates;
